import DataTable from "app/components/DataTable";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { BackWallTypeRow } from "../../types";
import { useStyles } from "./styles";

type Props = {
  rows: BackWallTypeRow[];
  loading?: boolean;
};

const BackWallTypeTable = ({ rows, loading = false }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();

  const columns = useMemo(
    () => [
      {
        id: "backWallCode",
        label: t("BACK_WALL_TYPE.TABLE.CODE"),
        align: "right",
        width: "33.33%",
        minWidth: "33.33%",
        format: (row: BackWallTypeRow) => (
          <span className={styles.textCell}>{row.backWallCode}</span>
        ),
      },
      {
        id: "backWallDesc",
        label: t("BACK_WALL_TYPE.TABLE.DESCRIPTION"),
        align: "right",
        width: "33.33%",
        minWidth: "33.33%",
        format: (row: BackWallTypeRow) => (
          <span className={styles.textCell}>{row.backWallDesc}</span>
        ),
      },
      {
        id: "bump",
        label: t("BACK_WALL_TYPE.TABLE.PROTRUSION"),
        align: "right",
        width: "33.33%",
        minWidth: "33.33%",
        format: (row: BackWallTypeRow) => (
          <span className={styles.numberCell}>{row.bump}</span>
        ),
      },
    ],
    [styles, t]
  );

  return (
    <div className={styles.root} dir="rtl">
      <DataTable
        rows={rows}
        columns={columns}
        loading={loading && rows.length === 0}
        serialEnabled={false}
        noDataLabel={t("BACK_WALL_TYPE.EMPTY")}
      />
    </div>
  );
};

export default BackWallTypeTable;
